
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "startMapTestingSubscription",
      resolverType: "mutation",
      routePath: "/startMapTestingSubscription",
      httpMethod: "POST",
    });
  